import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { keyframes } from '@emotion/core'

const getSpinAnimation = size => keyframes`
  0% {
    stroke-dashoffset: ${0.66 * size};
    transform: rotate(0deg);
  }
  50% {
    stroke-dashoffset: ${3.14 * size};
    transform: rotate(720deg);
  }
  100% {
    stroke-dashoffset: ${0.66 * size};
    transform: rotate(1080deg);
  }
`

const StyledSvg = styled('svg')`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  x: 0px;
  y: 0px;

  circle {
    fill: transparent;
    stroke: ${({ theme }) => theme.text.white };
    stroke-width: var(--icon-stroke-width, 2);
    stroke-linecap: round;
    stroke-dasharray: ${({ size }) => 3.14 * size};
    transform-origin: ${({ size }) => `${0.5 * size}px ${0.5 * size}px 0`};
    animation: ${({ size }) => getSpinAnimation(size)} 2s linear infinite;
  }
`

const Spinner = ({ size, ...rest }) => (
  <StyledSvg xmlns='http://www.w3.org/2000/svg' size={size} {...rest}>
    <circle cx={size / 2} cy={size / 2} r={size / 2 - 2} />
  </StyledSvg>
)

Spinner.propTypes = {
  size: PropTypes.number,
}

Spinner.defaultProps = {
  size: 100,
}

export default Spinner
